import Vue from 'vue'
import App from './App.vue'
import VueScrollStop from 'vue-scroll-stop'

var VueScrollTo = require('vue-scrollto');
Vue.use(VueScrollStop);
Vue.config.productionTip = false
Vue.use(VueScrollTo,{
  duration: 1000,
  easing: "ease",
})

new Vue({
  render: h => h(App),
}).$mount('#app')


